<template>
	<div class="content-container">
		<Pheader></Pheader>
		<router-view></router-view>
		<Pfooter></Pfooter>
		<tool></tool>
	</div>
</template>

<script>
// @ is an alias to /src
import Pheader from '@/components/pheader.vue'
import Pfooter from '@/components/pfooter.vue'
import tool from '@/components/tool.vue'
import {myMixin} from '@/mixin/mixin.js'
export default {
  name: 'Home',
  components: {
  	Pheader,
  	Pfooter,
  	tool
  },
  mixins:[myMixin],
  mounted(){
		// this.$nextTick(function(){
  //       	//渲染完成
  //      		var height = this.$refs.content.offsetHeight
  //      		this.footerAuto(height)
  //      	})
	}
}
</script>
